import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { heroBadges, productImage } from '../data/landing';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-900 text-cream" data-id="element-72" data-mp="9ktfls818azv">
      <div className="mx-auto max-w-4xl px-4 py-9 text-center sm:px-8 sm:py-14 lg:py-20" data-id="element-73" data-mp="9ip7ey33opts">
        <h1 className="font-display text-[2rem] font-extrabold uppercase leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-74" data-mp="4jm4pkalevoz">
          Mega Pack
          <span className="block text-gold-400" data-id="element-75" data-mp="xa4gratao7ej">Adolescencia Integral</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl font-sans text-sm leading-relaxed text-cream-200 sm:mt-5 sm:text-lg" data-id="element-76" data-mp="sarv2te5t6dj">
          ¿Cuántas veces necesitaste trabajar un tema con tus estudiantes y
          terminaste buscando durante horas qué actividad hacer?
        </p>

        <div className="mx-auto mt-5 w-[85%] max-w-lg sm:mt-7" data-id="element-77" data-mp="3cz5ug9c21vza">
          <img src={productImage} alt="Mega Pack Adolescencia Integral: 7 tomos digitales, bonos y recursos en tablet y notebook." className="w-full" width={1024} height={1024} loading="eager" decoding="async" fetchPriority="high" sizes="(min-width: 640px) 448px, 70vw" data-id="element-78" data-mp="381nrczkpyaz7" />
        </div>

        <p className="mx-auto mt-5 max-w-2xl text-left font-sans text-sm leading-relaxed text-cream sm:mt-7 sm:text-lg" data-id="element-79" data-mp="3e7uvnjuf8hm8">
          <strong className="font-bold" data-id="element-80" data-mp="30fy8zvbiuzx8">
            No necesitás seguir acumulando información.
          </strong>{' '}
          Necesitás recursos concretos, listos para usar, que te ayuden a
          abordar los desafíos reales de la adolescencia sin tener que crear
          cada propuesta desde cero.
        </p>

        <p className="mx-auto mt-4 max-w-2xl font-sans text-sm text-cream-200 sm:text-base" data-id="element-81" data-mp="2hj5i25ptub62">
          Más de <strong className="font-bold text-cream" data-id="element-82" data-mp="2lkilya9d04ac">7 tomos + 5 bonos</strong>{' '}
          con actividades, casos, dinámicas y recursos listos para trabajar con
          adolescentes durante todo el año.
        </p>

        <ul className="mt-5 flex flex-wrap justify-center gap-1.5 sm:mt-7 sm:gap-2" data-id="element-83" data-mp="natb7mfw54pz">
          {heroBadges.map(badge => <li key={badge} className="rounded-full border border-cream/20 bg-ink-800 px-2.5 py-1.5 font-sans text-[11px] font-medium text-cream-200 sm:px-4 sm:py-2 sm:text-sm" data-id="element-84" data-mp="id048r6rk6on">
              {badge}
            </li>)}
        </ul>

        <div className="mx-auto mt-6 max-w-xl sm:mt-9" data-id="element-85" data-mp="162uf537ivl69">
          <CtaButton data-id="element-86" data-mp="15zzqt0le1g7k">Quiero el Mega Pack</CtaButton>
          <p className="mt-3 font-sans text-xs text-cream-300 sm:text-sm" data-id="element-87" data-mp="111es55lsb4l8">
            Material digital • Acceso inmediato • Recursos listos para utilizar
          </p>
          <TrustStrip tone="dark" className="mt-3" data-id="element-88" data-mp="3ltgmlp4rwont" />
        </div>
      </div>
    </header>;
}